import axios from "axios";
import { token } from "../../Utils/helpers";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getCountryList= (code) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_COUNTRY_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },

        
      };

      const { data } = await axios.post(
        `${BASE_URL}/country/list-state-city`,
       code,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_COUNTRY_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_COUNTRY_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_COUNTRY_LIST_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

